import { useSelector } from "react-redux";
import { useGetProductQuery } from "../../store/services/productApi.js";
import MachineCard from "~/components/MachineCard/MachineCard.jsx";
import {
  GEN_1_MACHINE_PRODUCT_ID,
  DUET_MACHINE_PRODUCT_ID,
  GEN_1_MACHINE_PRODUCT_VARIANT_ID,
  DUET_MACHINE_PRODUCT_VARIANT_ID,
} from "../../utils/constants.js";
import "./MachineList.css";

const MachineList = () => {
  const selectedMachineVariantId = useSelector((state) => state.machine.selectedMachineVariantId);

  const {
    data: gen1MachineProduct,
    error: gen1Error,
    isLoading: gen1Loading,
  } = useGetProductQuery(GEN_1_MACHINE_PRODUCT_ID);

  const {
    data: duetMachineProduct,
    error: duetError,
    isLoading: duetLoading,
  } = useGetProductQuery(DUET_MACHINE_PRODUCT_ID);

  if (gen1Loading || duetLoading) return <p>Loading machines...</p>;
  if (gen1Error) return <p>Error loading Gen 1 Machine: {gen1Error.message}</p>;
  if (duetError) return <p>Error loading Duet Machine: {duetError.message}</p>;

  const products = [
    { data: gen1MachineProduct, productVariantId: GEN_1_MACHINE_PRODUCT_VARIANT_ID },
    { data: duetMachineProduct, productVariantId: DUET_MACHINE_PRODUCT_VARIANT_ID },
  ];

  return (
    <div className="machine-selection">
      {products.map((product) => (
        <MachineCard
          key={product.productVariantId}
          machineProduct={product.data}
          machineProductVariantId={product.productVariantId}
          selected={selectedMachineVariantId === product.productVariantId}
        />
      ))}
    </div>
  );
};

export default MachineList;
